(function () {
  'use strict';

  var params = new URLSearchParams(location.search);
  if (Array.from(params.keys()).some(function (key) {
    return key === 'sort_by' || key === 'q' || key.indexOf('filter.') === 0 || key.indexOf('okhomes_') === 0;
  })) return;

  function hash(value) {
    var result = 2166136261;
    for (var i = 0; i < value.length; i++) {
      result ^= value.charCodeAt(i);
      result = Math.imul(result, 16777619);
    }
    return result >>> 0;
  }

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  function handle(value) {
    var match = String(value || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function read(doc) {
    var data = doc.querySelector('script[id^="okhomes-list-map-data-"]');
    var properties = [];
    try { properties = JSON.parse(data.textContent || '[]'); } catch (_) {}
    var locations = new Map(properties.map(function (property) {
      return [handle(property.url), property.locality || property.province || ''];
    }));
    return Array.from(doc.querySelectorAll('#product-grid > li[data-okhomes-path]')).map(function (node) {
      var key = handle(node.dataset.okhomesPath);
      return { node: node, key: key, locality: normalize(locations.get(key) || node.dataset.okhomesLocality) || 'otras localidades' };
    });
  }

  function interleave(entries) {
    var groups = new Map();
    entries.forEach(function (entry) {
      if (!groups.has(entry.locality)) groups.set(entry.locality, []);
      groups.get(entry.locality).push(entry);
    });
    var names = Array.from(groups.keys()).sort(function (a, b) {
      return hash(a) - hash(b) || a.localeCompare(b);
    });
    names.forEach(function (name) {
      groups.get(name).sort(function (a, b) {
        return hash(a.key) - hash(b.key) || a.key.localeCompare(b.key);
      });
    });
    var result = [];
    while (result.length < entries.length) {
      names.forEach(function (name) {
        var group = groups.get(name);
        if (group.length) result.push(group.shift());
      });
    }
    return result;
  }

  function start() {
    var grid = document.getElementById('product-grid');
    var container = document.getElementById('ProductGridContainer');
    if (!grid || !container || !grid.dataset.okhomesPages) return;
    var total = Number(grid.dataset.okhomesPages) || 1;
    if (total < 2 || total > 30) return;
    var perPage = Number(grid.dataset.okhomesPageSize) || grid.querySelectorAll(':scope > li[data-okhomes-path]').length;
    if (!perPage) return;
    var initialPage = Math.max(1, Math.min(total, Number(params.get('page')) || 1));
    function loadPages() {
      var jobs = [];
      for (var page = 1; page <= total; page++) {
        if (page === initialPage) {
          jobs.push(Promise.resolve(read(document)));
          continue;
        }
        var url = new URL(location.href);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', grid.dataset.id);
        jobs.push(fetch(url.toString(), { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw Error('No se pudo cargar el listado');
          return response.text();
        }).then(function (html) {
          var cards = read(new DOMParser().parseFromString(html, 'text/html'));
          if (!cards.length) throw Error('Página incompleta');
          return cards;
        }));
      }
      return Promise.all(jobs);
    }
    loadPages().then(function (pages) {
      if (!grid.isConnected || new URLSearchParams(location.search).has('okhomes_place') || new URLSearchParams(location.search).has('okhomes_zone')) return;
      var unique = new Map();
      pages.forEach(function (items) {
        items.forEach(function (item) {
          if (item.key && !unique.has(item.key)) unique.set(item.key, item);
        });
      });
      var entries = interleave(Array.from(unique.values()));
      if (entries.length < perPage) return;
      var originalPagination = container.querySelector('.pagination-wrapper');
      var navigation = document.createElement('nav');
      navigation.className = 'okhomes-diverse-pagination';
      navigation.setAttribute('aria-label', 'Páginas del listado de propiedades');
      var previous = document.createElement('button');
      previous.type = 'button';
      previous.textContent = '‹ Anterior';
      var count = document.createElement('span');
      count.setAttribute('aria-live', 'polite');
      var next = document.createElement('button');
      next.type = 'button';
      next.textContent = 'Siguiente ›';
      navigation.append(previous, count, next);
      var style = document.createElement('style');
      style.textContent = '.okhomes-diverse-pagination{display:flex;align-items:center;justify-content:center;gap:1.5rem;margin:2.5rem auto;color:#176b36;font-weight:700}.okhomes-diverse-pagination button{min-height:44px;padding:.6rem 1.2rem;border:1px solid #198b3b;border-radius:999px;background:#fff;color:#176b36;font:inherit;cursor:pointer}.okhomes-diverse-pagination button:disabled{opacity:.45;cursor:default}.okhomes-diverse-pagination button:focus-visible{outline:3px solid #176b36;outline-offset:2px}';
      container.append(style, navigation);
      if (originalPagination) originalPagination.hidden = true;
      var pageCount = Math.ceil(entries.length / perPage);
      var current = 1;
      function render(page, updateUrl) {
        current = Math.max(1, Math.min(pageCount, page));
        var fragment = document.createDocumentFragment();
        entries.slice((current - 1) * perPage, current * perPage).forEach(function (item) {
          item.node.classList.remove('scroll-trigger', 'animate--slide-in');
          fragment.appendChild(item.node);
        });
        grid.replaceChildren(fragment);
        previous.disabled = current === 1;
        next.disabled = current === pageCount;
        count.textContent = current + ' / ' + pageCount;
        if (updateUrl) {
          var url = new URL(location.href);
          if (current === 1) url.searchParams.delete('page');
          else url.searchParams.set('page', String(current));
          history.pushState({ okhomesDiversePage: current }, '', url);
          var header = document.querySelector('.section-header');
          var headerStyle = header ? getComputedStyle(header) : null;
          var headerHeight = headerStyle && (headerStyle.position === 'sticky' || headerStyle.position === 'fixed') ? header.offsetHeight : 0;
          var headerTop = headerHeight ? Math.max(0, parseFloat(headerStyle.top) || 0) : 0;
          var firstCard = grid.querySelector(':scope > li[data-okhomes-path]') || container;
          window.scrollTo({
            top: Math.max(0, window.scrollY + firstCard.getBoundingClientRect().top - headerHeight - headerTop - 16),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }
      }
      previous.addEventListener('click', function () { render(current - 1, true); });
      next.addEventListener('click', function () { render(current + 1, true); });
      window.addEventListener('popstate', function () {
        var page = Number(new URLSearchParams(location.search).get('page')) || 1;
        render(page, false);
      });
      render(initialPage, false);
    }).catch(function () {
      // Keep Shopify's original listing and pagination when a page is unavailable.
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

